<header class="app-header">
  <button class="icon-btn menu-btn" (click)="menuToggle.emit()" title="Toggle menu">
    <span class="material-symbols-outlined">menu</span>
  </button>

  <div class="header-spacer"></div>

  <div class="header-actions">
    <a href="/" target="_blank" class="online-btn" [title]="'header.online_site' | translate">
      <span class="material-symbols-outlined">open_in_new</span>
      <span class="online-label">{{ 'header.online_site' | translate }}</span>
    </a>

    <button class="icon-btn" (click)="theme.toggle()" [title]="theme.isDark ? 'Switch to light mode' : 'Switch to dark mode'">
      <span class="material-symbols-outlined">{{ theme.isDark ? 'light_mode' : 'dark_mode' }}</span>
    </button>

    <button class="icon-btn lang-toggle-admin" (click)="toggleLang()" [class.is-ar]="currentLang === 'ar'" title="Switch language">
      <span class="lt-en">EN</span>
      <span class="lt-sep">|</span>
      <span class="lt-ar">ع</span>
    </button>

    <button class="icon-btn" [title]="'header.notifications' | translate">
      <span class="material-symbols-outlined">notifications</span>
    </button>

    <div class="user-chip-wrap">
      <button class="user-chip" (click)="toggleUserMenu()">
        <span class="material-symbols-outlined user-icon">account_circle</span>
        <span class="user-name">Admin</span>
        <span class="material-symbols-outlined chevron-icon">
          {{ showUserMenu ? 'expand_less' : 'expand_more' }}
        </span>
      </button>

      <div class="user-dropdown" [class.open]="showUserMenu">
        <a class="dropdown-item" routerLink="/main/change-password" (click)="showUserMenu = false">
          <span class="material-symbols-outlined">lock_reset</span>
          {{ 'header.change_pw' | translate }}
        </a>
        <div class="dropdown-divider"></div>
        <button class="dropdown-item dropdown-item--danger" (click)="logout()">
          <span class="material-symbols-outlined">logout</span>
          {{ 'header.logout' | translate }}
        </button>
      </div>
    </div>
  </div>
</header>
<div class="header-divider"></div>
